export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13995.748d1fd7.jpg";